import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';

export const coreComponentsFr = createTranslationMessages({
  ref: coreComponentsTranslationRef,
  full: true,
  messages: {
    'table.filter.title': 'Filtres',
    'table.filter.placeholder': 'Tous les résultats',
    'table.filter.clearAll': 'Tout effacer',
    'table.body.emptyDataSourceMessage': 'Aucun enregistrement à afficher',
    'table.header.actions': 'Actions',
    'table.toolbar.search': 'Filtrer',
    'table.pagination.firstTooltip': 'Première page',
    'table.pagination.labelDisplayedRows': '{from}-{to} sur {count}',
    'table.pagination.labelRowsSelect': 'lignes',
    'table.pagination.lastTooltip': 'Dernière page',
    'table.pagination.nextTooltip': 'Page suivante',
    'table.pagination.previousTooltip': 'Page précédente',
    'signIn.title': 'Connexion',
    'signIn.loginFailed': 'Échec de la connexion',
    'signIn.customProvider.title': 'Utilisateur personnalisé',
    'signIn.customProvider.subtitle':
      'Saisissez votre propre identifiant utilisateur et vos informations d’identification.\n Cette sélection ne sera pas enregistrée.',
    'signIn.customProvider.userId': 'Identifiant utilisateur',
    'signIn.customProvider.tokenInvalid':
      'Le token n’est pas un token JWT OpenID Connect valide',
    'signIn.customProvider.continue': 'Continuer',
    'signIn.customProvider.idToken': 'Token d’identité (facultatif)',
    'signIn.guestProvider.title': 'Invité',
    'signIn.guestProvider.enter': 'Entrer',
    'signIn.guestProvider.subtitle':
      'Entrez en tant qu’utilisateur invité.\n Vous n’aurez pas d’identité vérifiée, ce qui peut rendre certaines fonctionnalités indisponibles.',
    skipToContent: 'Passer au contenu',
    'copyTextButton.tooltipText': 'Texte copié dans le presse-papiers',
    'simpleStepper.finish': 'Terminer',
    'simpleStepper.reset': 'Réinitialiser',
    'simpleStepper.next': 'Suivant',
    'simpleStepper.skip': 'Passer',
    'simpleStepper.back': 'Retour',
    'errorPage.title': 'On dirait que quelqu’un a lâché le micro !',
    'errorPage.subtitle': 'ERREUR {{status}} : {{statusMessage}}',
    'errorPage.goBack': 'Retour',
    'errorPage.showMoreDetails': 'Afficher plus de détails',
    'errorPage.showLessDetails': 'Afficher moins de détails',
    'emptyState.missingAnnotation.title': 'Annotation manquante',
    'emptyState.missingAnnotation.actionTitle':
      'Ajoutez l’annotation au YAML de votre composant comme indiqué dans l’exemple mis en évidence ci-dessous :',
    'emptyState.missingAnnotation.readMore': 'En savoir plus',
    'supportConfig.default.title': 'Support non configuré',
    'supportConfig.default.linkTitle':
      'Ajouter la clé de configuration `app.support`',
    'errorBoundary.title': 'Veuillez contacter {{slackChannel}} pour obtenir de l’aide.',
    'oauthRequestDialog.message':
      'Connectez-vous pour autoriser {{appTitle}} à accéder aux API et identités {{provider}}.',
    'oauthRequestDialog.title': 'Connexion requise',
    'oauthRequestDialog.authRedirectTitle':
      'Cela déclenchera une redirection HTTP vers la page de connexion OAuth.',
    'oauthRequestDialog.login': 'Se connecter',
    'oauthRequestDialog.rejectAll': 'Tout refuser',
    'supportButton.title': 'Support',
    'supportButton.close': 'Fermer',
    'alertDisplay.message_one': '({{ count }} nouveau message)',
    'alertDisplay.message_other': '({{ count }} nouveaux messages)',
    'autoLogout.stillTherePrompt.title': 'Déconnexion pour cause d’inactivité',
    'autoLogout.stillTherePrompt.buttonText': 'Oui ! Ne me déconnectez pas',
    'dependencyGraph.fullscreenTooltip': 'Basculer en plein écran',
    'proxiedSignInPage.title':
      'Vous ne semblez pas être connecté. Veuillez essayer de recharger la page du navigateur.',
    'logViewer.searchField.placeholder': 'Rechercher',
    'logViewer.downloadBtn.tooltip': 'Télécharger les logs',
    'logViewer.copyBtn.tooltip': 'Copier les logs',
  },
});
